import ProdutoServicoList from './cadastro';
import VisualizarProdutoServico from './visualizar';

export { ProdutoServicoList, VisualizarProdutoServico };
